import { createComponent } from "@helpers/admin";
import TabSectionComponent from "@template/blocks/TabSection/component";

export const Tabs = createComponent({
  label: "Tabs",
  component: TabSectionComponent,
  fields: {
    heading: {
      label: "Heading",
      type: "textarea",
    },
    tabs: {
      label: "Tabs",
      type: "array",
      default_items: 2,
      arrayFields: {
        title: {
          label: "Title",
          type: "text",
        },
        subtitle: {
          label: "Subtitle",
          type: "text",
        },
        image: {
          label: "Image",
          type: "image",
        },
        icon: {
          label: "Icon",
          type: "icon",
        },
        bullets: {
          label: "Bullet Points",
          type: "array",
          arrayFields: {
            copy: {
              label: "Text",
              type: "text",
            },
            href: {
              label: "Link",
              type: "text",
            },
          },
        },
      },
    },
    alternative_styling: {
      label: "Alternative Styling",
      type: "boolean",
    },
  },
});
